import { Navigate, useLocation } from 'react-router';
import queryString from 'query-string';

export const Start = () => {
  const { search } = useLocation();
  const { token } = queryString.parse(search);
  console.log(token);
  if (token && typeof token === 'string') {
    sessionStorage.setItem('access_token', token);
    return <Navigate to="/" replace />;
  } else {
    return (
      <div className="l-wrap-xs u-pt100">
        <div className="l-box-message">
          <p className="m-title-sub u-pt0 u-ta-c">エラーが発生しました</p>
        </div>
      </div>
    );
  }
};
